import { useTranslation } from 'react-i18next';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetFamilyMembers } from '@/common/integrations/menhir/employee/employee/employee.hooks';
import { useCanEmployeeManageFamilyMembers } from '@/common/utils/family-members';

export const ProfilePersonalSection = () => {
  const { t } = useTranslation();
  const { employee } = useEmployeeDetails();
  const canManageFamilyMembers = useCanEmployeeManageFamilyMembers();
  const { familyMembers } = useGetFamilyMembers();

  const familyMembersCount = familyMembers?.length || 0;

  return (
    <CardActionGroup
      title={t('dashboard.profile.sections.profile.title')}
      size="sm"
    >
      <CardActionLink
        href={ROUTES.PERSONAL_DETAILS}
        icon={<Icon icon="user" />}
        title={t(
          'dashboard.profile.sections.profile.links.personal_info.title'
        )}
        description={employee?.name}
      />
      {canManageFamilyMembers && (
        <CardActionLink
          href={ROUTES.FAMILY_MEMBERS}
          icon={<Icon icon="family-pants" />}
          title={t(
            'dashboard.profile.sections.profile.links.family_members.title'
          )}
          description={t(
            'dashboard.profile.sections.profile.links.family_members.count',
            {
              count: familyMembersCount,
            }
          )}
        />
      )}
    </CardActionGroup>
  );
};
